import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_CASE_VOLUME_LIST } from "../services/get-case-volume";
import { cloneDeep, cloneDeepWith, isEqual } from "lodash";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../../common_components/mdae-framework";
const initialState = {
  isLoading: false,
  caseCountList: [],
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {  
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_CASE_VOLUME_LIST)(action)) {
        return { ...state, auditList: [] };
      }
      if (isAsyncComplete(GET_CASE_VOLUME_LIST)(action)) {
        const response = action.response;
        return { ...state, caseCountList: response };
      }      
      return state;
    default:
      return state;
  }
}